import PropTypes from 'prop-types';
import React from 'react';

const CPlusplusInactive = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ddd_1112_9470)">
      <rect x="392" y="92" width="800" height="556" rx="12" fill="white" />
    </g>
    <rect opacity="0.1" x="392" y="417" width="800" height="24" fill="#FD0054" />
    <g clipPath="url(#clip0_1112_9470)">
      <path
        d="M1167.16 610C1167.68 609.13 1168 608.15 1168 607.271V576.729C1168 575.849 1167.68 574.87 1167.16 574L1135 592L1167.16 610Z"
        fill="#00599C"
      />
      <path
        d="M1137.86 627.34L1165.14 612.069C1165.93 611.629 1166.64 610.87 1167.16 610L1135 592L1102.84 610C1103.36 610.87 1104.07 611.63 1104.86 612.069L1132.14 627.34C1133.71 628.22 1136.29 628.22 1137.86 627.34Z"
        fill="#004482"
      />
      <path
        d="M1167.16 574C1166.64 573.13 1165.93 572.37 1165.14 571.931L1137.86 556.66C1136.29 555.78 1133.71 555.78 1132.14 556.66L1104.86 571.931C1103.29 572.81 1102 574.97 1102 576.729V607.271C1102 608.15 1102.32 609.13 1102.84 610L1135 592L1167.16 574Z"
        fill="#659AD2"
      />
      <path
        d="M1135 613.327C1122.87 613.327 1113 603.76 1113 592C1113 580.24 1122.87 570.673 1135 570.673C1142.83 570.673 1150.13 574.756 1154.05 581.33L1144.53 586.671C1142.57 583.38 1138.91 581.336 1135 581.336C1128.93 581.336 1124 586.12 1124 592C1124 597.88 1128.93 602.664 1135 602.664C1138.92 602.664 1142.57 600.619 1144.53 597.329L1154.05 602.669C1150.13 609.243 1142.83 613.327 1135 613.327Z"
        fill="white"
      />
      <path
        d="M1157 590.815H1154.55V588.445H1152.11V590.815H1149.66V593.185H1152.11V595.554H1154.55V593.185H1157V590.815Z"
        fill="white"
      />
      <path
        d="M1166.17 590.815H1163.72V588.445H1161.28V590.815H1158.84V593.185H1161.28V595.554H1163.72V593.185H1166.17V590.815Z"
        fill="white"
      />
    </g>
    <rect opacity="0.1" x="441" y="129" width="1" height="519" fill="#181A1B" />
    <text
      opacity="0.6"
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="408.184" y="160.938">
        14&#10;
      </tspan>
      <tspan x="408.184" y="181.938">
        15&#10;
      </tspan>
      <tspan x="408.184" y="202.938">
        16&#10;
      </tspan>
      <tspan x="408.184" y="223.938">
        17&#10;
      </tspan>
      <tspan x="408.184" y="244.938">
        18&#10;
      </tspan>
      <tspan x="408.184" y="265.938">
        19&#10;
      </tspan>
      <tspan x="408.184" y="286.938">
        20&#10;
      </tspan>
      <tspan x="408.184" y="307.938">
        21&#10;
      </tspan>
      <tspan x="408.184" y="328.938">
        22&#10;
      </tspan>
      <tspan x="408.184" y="349.938">
        23&#10;
      </tspan>
      <tspan x="408.184" y="370.938">
        24&#10;
      </tspan>
      <tspan x="408.184" y="391.938">
        25&#10;
      </tspan>
      <tspan x="408.184" y="412.938">
        26&#10;
      </tspan>
      <tspan x="408.184" y="433.938">
        27&#10;
      </tspan>
      <tspan x="408.184" y="454.938">
        28&#10;
      </tspan>
      <tspan x="408.184" y="475.938">
        29&#10;
      </tspan>
      <tspan x="408.184" y="496.938">
        30&#10;
      </tspan>
      <tspan x="408.184" y="517.938">
        31&#10;
      </tspan>
      <tspan x="408.184" y="538.938">
        32&#10;
      </tspan>
      <tspan x="408.184" y="559.938">
        33&#10;
      </tspan>
      <tspan x="408.184" y="580.938">
        34&#10;
      </tspan>
      <tspan x="408.184" y="601.938">
        35&#10;
      </tspan>
      <tspan x="408.184" y="622.938">
        36
      </tspan>
    </text>
    <path
      d="M392 104C392 97.3726 397.373 92 404 92H1180C1186.63 92 1192 97.3726 1192 104V128H392V104Z"
      fill="white"
    />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="600"
      letterSpacing="0em"
    >
      <tspan x="777.109" y="114.9">
        C++
      </tspan>
    </text>
    <circle cx="414" cy="110" r="6" fill="#FD0054" />
    <circle cx="434" cy="110" r="6" fill="#FFB31A" />
    <circle cx="454" cy="110" r="6" fill="#00CC21" />
    <rect opacity="0.1" x="392" y="128" width="800" height="1" fill="#181A1B" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="533.266" y="160.938">
        {' '}
        &#60;
      </tspan>
      <tspan x="600.531" y="160.938">
        {' '}
        n&#62;&#10;
      </tspan>
      <tspan x="499.633" y="181.938">
        {' '}
      </tspan>
      <tspan x="558.49" y="181.938">
        (
      </tspan>
      <tspan x="608.939" y="181.938">
        {' '}
        std::array&#60;std::array&#60;
      </tspan>
      <tspan x="827.553" y="181.938">
        , n&#62;, n&#62; &#38;board,{' '}
      </tspan>
      <tspan x="1046.17" y="181.938">
        {' '}
        &#38;row,&#10;
      </tspan>
      <tspan x="466" y="202.938">
        {' '}
      </tspan>
      <tspan x="642.572" y="202.938">
        {' '}
        &#38;col) {'{'}&#10;
      </tspan>
      <tspan x="466" y="223.938">
        {' '}
      </tspan>
      <tspan x="524.857" y="223.938">
        {' '}
        i ={' '}
      </tspan>
      <tspan x="575.307" y="223.938">
        , j ={' '}
      </tspan>
      <tspan x="634.164" y="223.938">
        ;&#10;
      </tspan>
      <tspan x="466" y="244.938" />
      <tspan x="466" y="265.938">
        {' '}
      </tspan>
      <tspan x="466" y="286.938">
        {' '}
      </tspan>
      <tspan x="524.857" y="286.938">
        {' '}
        (i ={' '}
      </tspan>
      <tspan x="583.715" y="286.938">
        ; i &#60; col; i++) {'{'}&#10;
      </tspan>
      <tspan x="466" y="307.938">
        {' '}
      </tspan>
      <tspan x="550.082" y="307.938">
        {' '}
        (board[row][i]) {'{'}&#10;
      </tspan>
      <tspan x="466" y="328.938">
        {' '}
      </tspan>
      <tspan x="617.348" y="328.938">
        {' '}
      </tspan>
      <tspan x="667.797" y="328.938">
        ;&#10;
      </tspan>
      <tspan x="466" y="349.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="466" y="370.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="466" y="391.938" />
      <tspan x="466" y="412.938">
        {' '}
        // Check upper diagonal on left side&#10;
      </tspan>
      <tspan x="466" y="433.938">
        {' '}
      </tspan>
      <tspan x="524.857" y="433.938">
        {' '}
        (i = row, j = col; i &#62;={' '}
      </tspan>
      <tspan x="743.471" y="433.938">
        {' '}
        &#38;&#38; j &#62;={' '}
      </tspan>
      <tspan x="827.553" y="433.938">
        ; i--, j--) {'{'}&#10;
      </tspan>
      <tspan x="466" y="454.938">
        {' '}
      </tspan>
      <tspan x="550.082" y="454.938">
        {' '}
        (board[i][j]) {'{'}&#10;
      </tspan>
      <tspan x="466" y="475.938">
        {' '}
      </tspan>
      <tspan x="617.348" y="475.938">
        {' '}
      </tspan>
      <tspan x="667.797" y="475.938">
        ;&#10;
      </tspan>
      <tspan x="466" y="496.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="466" y="517.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="466" y="538.938">
        {' '}
      </tspan>
      <tspan x="466" y="559.938">
        {' '}
      </tspan>
      <tspan x="524.857" y="559.938">
        {' '}
        (i = row, j = col; j &#62;={' '}
      </tspan>
      <tspan x="743.471" y="559.938">
        {' '}
        &#38;&#38; i &#60; n; i++, j--) {'{'}&#10;
      </tspan>
      <tspan x="466" y="580.938">
        {' '}
      </tspan>
      <tspan x="550.082" y="580.938">
        {' '}
        (board[i][j]) {'{'}&#10;
      </tspan>
      <tspan x="466" y="601.938">
        {' '}
      </tspan>
      <tspan x="617.348" y="601.938">
        {' '}
      </tspan>
      <tspan x="667.797" y="601.938">
        ;&#10;
      </tspan>
      <tspan x="466" y="622.938">
        {' '}
        {'}'}
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="466" y="160.938">
        template
      </tspan>
      <tspan x="466" y="181.938">
        bool
      </tspan>
      <tspan x="566.898" y="181.938">
        const
      </tspan>
      <tspan x="802.328" y="181.938">
        int
      </tspan>
      <tspan x="970.492" y="181.938">
        const int
      </tspan>
      <tspan x="566.898" y="202.938">
        const int
      </tspan>
      <tspan x="499.633" y="223.938">
        int
      </tspan>
      <tspan x="499.633" y="286.938">
        for
      </tspan>
      <tspan x="533.266" y="307.938">
        if
      </tspan>
      <tspan x="566.898" y="328.938">
        return
      </tspan>
      <tspan x="499.633" y="433.938">
        for
      </tspan>
      <tspan x="533.266" y="454.938">
        if
      </tspan>
      <tspan x="566.898" y="475.938">
        return
      </tspan>
      <tspan x="499.633" y="559.938">
        for
      </tspan>
      <tspan x="533.266" y="580.938">
        if
      </tspan>
      <tspan x="566.898" y="601.938">
        return
      </tspan>
    </text>
    <text
      fill="#001A9B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="550.082" y="160.938">
        size_t
      </tspan>
      <tspan x="566.898" y="223.938">
        0
      </tspan>
      <tspan x="625.756" y="223.938">
        0
      </tspan>
      <tspan x="575.307" y="286.938">
        0
      </tspan>
      <tspan x="625.756" y="328.938">
        false
      </tspan>
      <tspan x="735.062" y="433.938">
        0
      </tspan>
      <tspan x="819.145" y="433.938">
        0
      </tspan>
      <tspan x="625.756" y="475.938">
        false
      </tspan>
      <tspan x="735.062" y="559.938">
        0
      </tspan>
      <tspan x="625.756" y="601.938">
        false
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="508.041" y="181.938">
        isSafe
      </tspan>
    </text>
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="499.633" y="265.938">
        // Check this row on left side&#10;
      </tspan>
      <tspan x="499.633" y="538.938">
        // Check lower diagonal on left side&#10;
      </tspan>
    </text>
    <path
      d="M382 428H298V348"
      stroke="#AFB5B6"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="0.01 10"
    />
    <circle cx="298" cy="268" r="72" fill="url(#paint0_linear_1112_9470)" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="290.165" y="229.9">
        IO
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="44"
      fontWeight="300"
      letterSpacing="0em"
    >
      <tspan x="262.244" y="275.4">
        31%
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="13"
      letterSpacing="0em"
    >
      <tspan x="269.704" y="298.55">
        Address:&#10;
      </tspan>
      <tspan x="266.117" y="314.55">
        0x4553e0
      </tspan>
    </text>
    <defs>
      <filter
        id="filter0_ddd_1112_9470"
        x="352"
        y="72"
        width="880"
        height="636"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_9470" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_9470"
          result="effect2_dropShadow_1112_9470"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_9470"
          result="effect3_dropShadow_1112_9470"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_9470"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_9470"
        x1="370"
        y1="196"
        x2="226"
        y2="340"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCFDFD" />
        <stop offset="1" stopColor="#F4F5F6" />
      </linearGradient>
      <clipPath id="clip0_1112_9470">
        <rect width="66" height="72" fill="white" transform="translate(1102 556)" />
      </clipPath>
    </defs>
  </svg>
);

CPlusplusInactive.propTypes = {
  className: PropTypes.string,
};

CPlusplusInactive.defaultProps = {
  className: null,
};

export default CPlusplusInactive;
